class MapController {

    constructor() {

        var that = this;

        that.map = $('#vah_map');

        if ( that.map.length === 0 ) return;

        that.container = that.map.closest('.flex-contact-banner');

        var mapOptions = {
            cluster: true,
            elt: that.map,
            points: that.getAgencies()
        };
        that.initMap(mapOptions);

        // On change select department
        $('#geoLocAgency').on('change', function (e) {
            e.preventDefault();

        });
        // autocomplete
        var input = document.getElementById('geoLocAddress'),
        options = {
            componentRestrictions: {
                country: 'fr'
            },
            types: ['geocode']
        },
        autocomplete = new google.maps.places.Autocomplete(input, options);

        autocomplete.addListener('place_changed', function() {
            var place = autocomplete.getPlace();
            that.resetSelector();

            if(place.geometry !== undefined) {

                that.lat = place.geometry.location.lat();
                that.lng = place.geometry.location.lng();
                that.centerMap();
                var marker = that.findNearestAgency();
                that.openMarker(marker);

                var location = autocomplete.getPlace().formatted_address;

                var vars = {
                    'event': 'store-search',
                    'location' : location,
                };

                window.dataLayer = dataLayer || [];
                dataLayer.push(vars);
            }

        });
        $('.contact_map').on('submit', function (e) {
            e.preventDefault();
        });
        $('#contact_map').on('submit', function (e) {
            e.preventDefault();
        });
        // Localisation
        $('a.getGeoLoc').click(function (e) {
            e.preventDefault();
            that.element = $(this);
            that.resetInput();
            that.resetSelector();

            if ( navigator.geolocation ) {
                navigator.geolocation.getCurrentPosition(function (position) {
                    that.lat = position.coords.latitude;
                    that.lng = position.coords.longitude;

                    that.centerMap();
                    var marker = that.findNearestAgency();
                    that.openMarker(marker);
                }, function (err) {
                    
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $("#search-bar-maps").offset().top
                    }, 400);
                    
                    that.element.parent().find('p').remove();
                    that.element.parent().append('<p>Nous n\'avons pas pu vous gélocaliser.</p>');
                });
            } else {
                
                $([document.documentElement, document.body]).animate({
                    scrollTop: $("#search-bar-maps").offset().top
                }, 400);

                that.element.parent().find('p').remove();
                that.element.parent().append('<p>Nous n\'avons pas pu vous gélocaliser.</p>');
            }
        });
        // On click agence
        that.container.find('.selector select').on('change', function (e) {
            e.preventDefault();
            that.resetInput();
            var index = $(this).val();
            var marker = that.markers[that.tempMarkersIds[index]];
            that.openMarker(marker);
        });
    }

    resetSelector() {
        this.container.find('.selector select').val('');
        this.container.find('.selector .value').text('Choisissez une agence');
    }

    resetInput() {
        this.container.find('#geoLocAddress').val('');
    }

    initMap( options ) {
        this.options = options;
        this.infowindow;
        this.bounds = new google.maps.LatLngBounds();
        this.styles = [
            {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#444444"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#f2f2f2"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 45
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#dde6e8"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            }
        ];
        this.map = new google.maps.Map(this.options.elt.get(0), {
            center: {lat: 45.946268, lng: 6.072141999999985},
            zoom: 6
        });
        this.map.setOptions({styles: this.styles});
        this.markers = [];
        this.tempMarkersIds = [];
        this.initMarkers();
    }

    initMarkers() {
        var self = this;

        $.each(this.options.points, function(i, elt){

            if ( elt.type == "ASDIA" ) {
                marker_map = marker_map_asdia;
            } else if ( elt.type == "SANTE PLUS" ) {  
                marker_map = marker_map_sante_plus;
            } else{ 
                marker_map = marker_map_default;
            }

            var image = {
                url: marker_map,
                size: new google.maps.Size(25, 32),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(12, 32),
                scaledSize: new google.maps.Size(25, 32)
            };

            var marker = new google.maps.Marker({
                map: self.map,
                icon: image,
                position: new google.maps.LatLng(elt.lat, elt.lng),
                title: elt.title,
            });  

            marker.addListener('click', function() {
                self.addToolTip(marker, elt);
            });

            var pos = self.markers.push(marker);
            self.tempMarkersIds[elt.id] = pos - 1;
            //self.markers[elt.id] = marker;
            self.bounds.extend(new google.maps.LatLng(elt.lat, elt.lng));

        });

        this.markers = self.markers;
        this.tempMarkersIds = self.tempMarkersIds;
        this.ajustAllMarkers();
        this.makeClusters();
    }

    ajustAllMarkers() {
        this.map.fitBounds(this.bounds);
    }

    getAgencies() {
        return agencies;
    }

    makeClusters() {
        var size = 40;
        var gridSize = 20;

        var mcOptions = {gridSize: gridSize, styles: [ { textColor: 'white', height: size, url: cluster_map, width: size}]}
        var markerCluster = new MarkerClusterer(this.map, this.markers, mcOptions);

    }

    addToolTip(marker, data) {

        if(this.infowindow) this.infowindow.close();

        this.infowindow = new google.maps.InfoWindow({
            content: this.nl2br(data.content)
        });

        this.infowindow.open(this.map,marker);

        if( this.map.getZoom() < 10 ){
            this.map.setZoom(10);
        }
        this.map.setCenter(marker.getPosition());
    }

    nl2br(str, is_xhtml) {
        var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');


        if(this.infowindow) this.infowindow.close();

        this.infowindow = new google.maps.InfoWindow({
            content: '<div class="toolTip"><div class="title"><strong>'+data.title+'</strong></div><div class="adress">'+nl2br(data.body)+'</div></div>'
        });

        this.infowindow.open(map,marker);
        this.map.setZoom(10);
        this.map.setCenter(marker.getPosition());
    }

    centerMap() {
        var center = new google.maps.LatLng(this.lat, this.lng);
        this.map.panTo(center);
        this.map.setZoom(10);
    }

    openMarker(marker) {

        $([document.documentElement, document.body]).animate({
            scrollTop: $("#search-bar-maps").offset().top
        }, 400);
        // marker.click(marker);
        google.maps.event.trigger(marker, 'click');
    }

    rad(x) {
        return x*Math.PI/180;
    }

    findNearestAgency() {
        var R = 6371; // radius of earth in km
        var distances = [];
        var closest = -1;
        for ( var i=0;i < this.markers.length; i++ ) {
            var mlat = this.markers[i].position.lat();
            var mlng = this.markers[i].position.lng();
            var dLat  = this.rad(mlat - this.lat);
            var dLong = this.rad(mlng - this.lng);
            var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                Math.cos(this.rad(this.lat)) * Math.cos(this.rad(this.lat)) * Math.sin(dLong/2) * Math.sin(dLong/2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
            var d = R * c;
            distances[i] = d;

            if ( closest == -1 || d < distances[closest] ) {
                closest = i;
            }
        }
        return this.markers[closest];
    }
}
